'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavigationBarControl = function NavigationBarControl(element, args) {
  _classCallCheck(this, NavigationBarControl);

  var header = document.createElement('header');
  var h1 = document.createElement('h1');
  var span = document.createElement('span');
  span.innerHTML = args.title;

  var addButton = function addButton(button) {
    var a = document.createElement('a');
    var spanIcon = document.createElement('span');
    spanIcon.innerHTML = button.icon;
    a.className = button.classes ? 'icon ' + button.classes : 'icon';
    a.onclick = button.onclick;
    a.appendChild(spanIcon);
    h1.appendChild(a);
  };

  if (args.primaryButton) {
    addButton(args.primaryButton);
  }

  if (args.leftHandButtons) {
    args.leftHandButtons.forEach(addButton);
  }

  if (args.secondaryButton) {
    addButton(args.secondaryButton);
  }

  h1.appendChild(span);

  if (args.rightHandButtons) {
    args.rightHandButtons.forEach(addButton);
  }

  header.appendChild(h1);

  if (args.contextMenu) {
    var contextMenuElementButton = document.createElement('a');
    var contextMenuElementIcon = document.createElement('span');
    contextMenuElementIcon.innerHTML = '\uE116';
    var contextMenuElement = document.createElement('nav');
    contextMenuElement.className = 'contextMenu invisible';

    var closeContextMenu = function closeContextMenu() {
      contextMenuElement.classList.add('invisible');
      removeEventListener('click', closeContextMenu, false);
    };

    var openContextMenu = function openContextMenu(e) {
      e.stopPropagation();
      contextMenuElement.classList.remove('invisible');
      addEventListener('click', closeContextMenu, false);
    };

    contextMenuElementButton.className = 'icon';
    contextMenuElementButton.onclick = openContextMenu;
    contextMenuElementButton.appendChild(contextMenuElementIcon);

    args.contextMenu.forEach(function (item) {
      var a = document.createElement('a');
      var spanIcon = document.createElement('span');
      spanIcon.innerHTML = item.icon;
      a.className = 'icon';
      a.onclick = item.onclick;
      a.innerHTML = item.label ? item.label : '';
      a.insertBefore(spanIcon, a.childNodes[0]);
      contextMenuElement.appendChild(a);
    });

    h1.appendChild(contextMenuElementButton);
    header.appendChild(contextMenuElement);
  }

  var fragment = document.createDocumentFragment();
  fragment.appendChild(header);

  element.appendChild(fragment);
};

exports.default = NavigationBarControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/NavigationBarControl.js
// module id = 17
// module chunks = 0